
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[eid]",
      function () {
        return require("private-next-pages/[eid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[eid]"])
      });
    }
  